<template>
  <form ref="form" action="./" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <input type="hidden" name="test_type" :value="abtest.abtest_type" />
    <div class="l-page l-page--abtest-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <h2 class="c-title__text c-title__text--blue u-fs34">配信メッセージの新規作成</h2>
            <div class="c-text">【コンテンツ比較のA/Bテスト】</div>
          </div>
          <div class="c-progress c-progress--abtest-message">
            <ul class="c-progress-list">
              <li class="c-progress-list__item">メッセージの作成<br />Aパターン</li>
              <li class="c-progress-list__item is-current">メッセージの作成<br />Bパターン</li>
              <!-- <li class="c-progress-list__item">配信条件の<br>設定</li> -->
              <li class="c-progress-list__item">配信内容の<br />確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit-confirm">
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">テスト名</div>
                <div class="p-message-edit-confirm__text">{{ abtest.abtest_name }}</div>
              </div>
              <div class="p-message-edit-confirm-list__item p-message-edit-confirm-list__item--desc">
                <div class="p-message-edit-confirm__title">テストする内容</div>
                <div class="p-message-edit-confirm__text">
                  {{ abtest.memo }}</div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">プッシュ対象</div>
                <div class="c-tag">
                  <ul class="c-tag-list">
                    <li v-if="messageB.service_type == 2" class="c-tag-list__item c-tag-list__item--green">ブラウザ</li>
                    <li v-if="messageB.service_type == 4" class="c-tag-list__item c-tag-list__item--green">カート</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-content l-main-content--half l-main-content--left">
          <message-form
            ref="messageForm"
            v-model="message"
            :custom-utm-parameters="customUtmParameters"
            @optimize-start="onStartOptimize"
            @optimize-end="onEndOptimize"
          />
        </div>
        <div class="l-main-content l-main-content--half l-main-content--right">
          <div class="p-message-preview">
            <div class="c-title c-title--left u-text-white-1">
              <div class="c-title__text u-fs--l ">プレビュー</div>
              <div class="c-text u-fs10">実際の配信メッセージと表示が異なることがあります</div>
            </div>
            <ul class="c-tab-list">
              <li
                class="c-tab-list__item"
                :class="{'is-active': previewType == 'desktop' }"
                data-type="desktop"
                @click="chengePreviewType('desktop')"
              >PCでの配信例</li>
              <li
                class="c-tab-list__item"
                :class="{'is-active': previewType == 'mobile' }"
                data-type="mobile"
                @click="chengePreviewType('mobile')"
              >スマホでの配信例</li>
            </ul>
            <div v-show="previewType == 'desktop'" class="p-message-preview-list">
              <message-preview
                :title="message.messageTitle"
                :text="message.messageText"
                :url="message.clickUrl"
                :icon-url="message.iconUrl"
                :large-image-url="message.largeImageUrl"
                :has-button-a="message.hasButtonA"
                :has-button-b="message.hasButtonB"
                :action-button-text-a="message.actionButtonTextA"
                :action-button-text-b="message.actionButtonTextB"
              />
            </div>
            <div v-show="previewType == 'mobile'" class="p-message-preview-list">
              <message-preview-sp
                :title="message.messageTitle"
                :text="message.messageText"
                :url="message.clickUrl"
                :icon-url="message.iconUrl"
                :large-image-url="message.largeImageUrl"
                :has-button-a="message.hasButtonA"
                :has-button-b="message.hasButtonB"
                :action-button-text-a="message.actionButtonTextA"
                :action-button-text-b="message.actionButtonTextB"
              />
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onQuitClick"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              :class="{ 'is-loading': isLoadingSaveBtn || isLoadingOptimizeImage }"
              :disabled="isLoadingSaveBtn || isLoadingOptimizeImage"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingEditAPatternBtn || isLoadingOptimizeImage }"
            :disabled="isLoadingEditAPatternBtn || isLoadingOptimizeImage"
            type="button"
            name="next"
            value="next"
            @click="onEditAPtternClick($event)"
          >
            <p class="c-btn__text">Aパターンを編集する</p>
          </button>
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingNextBtn || isLoadingOptimizeImage }"
            :disabled="isLoadingNextBtn || isLoadingOptimizeImage"
            type="button"
            name="next"
            value="next"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">確認画面へ</p>
          </button>
        </div>
      </div>
    </div>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </form>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    csrfToken: String,
    breadcrumbData: Array,
    abtest: Object,
    messageB: Object,
    linkData: Object,
    customUtmParameters: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      message: {
        messageTitle: null,
        messageText: null,
        clickUrl: null,
        iconUrl: null,
        selectedIconFile: null,
        largeImageUrl: null,
        selectedLargeImageFile: null,
        hasButtonA: false,
        hasButtonB: false,
        actionButtonTextA: null,
        actionButtonUrlA: null,
        actionButtonTextB: null,
        actionButtonUrlB: null,
        adFlag: null,
        customUtmParameter: null,
        customUtmParameterActionA: null,
        customUtmParameterActionB: null,
      },
      errorMessage: '',
      isError: false,
      isLoadingNextBtn: false,
      isLoadingSaveBtn: false,
      isLoadingEditAPatternBtn: false,
      isLoadingOptimizeImage: false,
      previewType: 'desktop',
    }
  },
  mounted: function() {
    import('../../funcs/pages/abtest-message-add').then(module => {
      module.AbtestMessageAdd();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });

    let message = this.messageB;

    this.message.messageTitle = message.message_title;
    this.message.messageText = message.message_text;
    this.message.clickUrl = message.click_url;
    if (message.action_button_text_a && message.action_button_url_a) {
      this.message.hasButtonA = true;
      this.message.actionButtonTextA = message.action_button_text_a;
      this.message.actionButtonUrlA = message.action_button_url_a;
    } else {
      this.message.hasButtonA = false;
    }
    if (message.action_button_text_b && message.action_button_url_b) {
      this.message.hasButtonB = true;
      this.message.actionButtonTextB = message.action_button_text_b;
      this.message.actionButtonUrlB = message.action_button_url_b;
    } else {
      this.message.hasButtonB = false;
    }

    if (message.image_url) {
      this.message.iconUrl = message.image_url;
    }
    if (message.large_image_url) {
      this.message.largeImageUrl = message.large_image_url;
    }
    if (message.ad_flag == 1) {
      this.message.adFlag = true;
    }
  },
  methods: {
    showCalendar: function(name) {
      $("*[name="+name+"]").click();
    },
    onSaveClick: function() {
      this.isLoadingSaveBtn = true;

      if(this.validate()){
        this.saveAbtest(this.linkData.listUrl,false);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingSaveBtn = false; }, 300);
      }
    },
    onQuitClick: function() {
      location.href = this.linkData.listUrl;
    },
    onEditAPtternClick: function(event) {
      event.preventDefault();
      this.isLoadingEditAPatternBtn = true;

      if(this.validate()){
        this.saveAbtest(this.linkData.patternAUrl, false);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingEditAPatternBtn = false; }, 300);
      }
    },
    onNextClick: function(event) {
      event.preventDefault();
      this.isLoadingNextBtn = true;

      if(this.validate()){
        this.saveAbtest(this.linkData.confirmUrl,true);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingNextBtn = false; }, 300);
      }
    },
    validate: function() {
      let isValid = true;
      let errors = {};

      this.$refs.messageForm.validate(errors);

      if(Object.keys(errors).length > 0){
        this.showErrors(errors);
        isValid = false;
      }

      return isValid;
    },
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    appendUtmParameter(url, value) {
      let parameterValue = this.customUtmParameters[value];
      // parameterValueが存在しない、または文字列でない場合は元のURLを返す
      if (!parameterValue || typeof parameterValue !== 'string') {
        return url;
      }
      if (parameterValue.startsWith('?') || parameterValue.startsWith('&')) {
        parameterValue = parameterValue.substring(1);
      }
      url += (url.includes('?') ? '&' : '?') + parameterValue;
      return url;
    },
    saveAbtest: function(completeUrl,hasArgument) {
      //*
      let params = new FormData();
      let clickUrl = this.message.clickUrl;
      if (this.message.customUtmParameter) {
        clickUrl = this.appendUtmParameter(clickUrl, this.message.customUtmParameter);
      }

      this.appendForm(params,'abtest_id',this.abtest.abtest_id);

      this.appendForm(params,'message_title',this.message.messageTitle);
      this.appendForm(params,'message_text',this.message.messageText);
      this.appendForm(params,'click_url',clickUrl);
      this.appendForm(params,'image_url',this.message.iconUrl);
      this.appendForm(params,'large_image_url',this.message.largeImageUrl);
      if(this.message.hasButtonA){
        let actionButtonUrlA = this.message.actionButtonUrlA;
        if (this.message.customUtmParameterActionA) {
          actionButtonUrlA = this.appendUtmParameter(actionButtonUrlA, this.message.customUtmParameterActionA);
        }
        this.appendForm(params,'action_button_text_a',this.message.actionButtonTextA);
        this.appendForm(params,'action_button_url_a',actionButtonUrlA);
        if(this.message.hasButtonB){
          let actionButtonUrlB = this.message.actionButtonUrlB;
          if (this.message.customUtmParameterActionB) {
            actionButtonUrlB = this.appendUtmParameter(actionButtonUrlB, this.message.customUtmParameterActionB);
          }
          this.appendForm(params,'action_button_text_b',this.message.actionButtonTextB);
          this.appendForm(params,'action_button_url_b',actionButtonUrlB);
        }
      }
      params.append('ad_flag', this.message.adFlag ? 1 : 0);
      params.append('icon_file',this.message.selectedIconFile);
      params.append('large_image_file',this.message.selectedLargeImageFile);

      axios.post('/api/abtest/save-message-b',params)
        .then(res => {
          if(this.handleResponse(res)){
            let url = completeUrl;
            if(hasArgument){
              url += '?abtest_id=' + res.data.abtest_id;
            }
            location.href = url;
          } else {
            this.isError = true;
            this.errorMessage = 'メッセージの保存に失敗しました';
          }
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
            this.isLoadingEditAPatternBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'メッセージの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
            this.isLoadingEditAPatternBtn = false;
          }, 300);
        });
    },
    // プレビューのタブを切り替える
    chengePreviewType: function(type) {
      this.previewType = type;
    },
    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // 画像最適化処理の開始
    onStartOptimize: function() {
      this.isLoadingOptimizeImage = true;
    },
    // 画像最適化処理の完了
    onEndOptimize: function() {
      this.isLoadingOptimizeImage = false;
    },
  }
}
</script>
